export const contact = {
    phone: '+49 (0) 40 526 778 200',
    mobile: '+49 175 327 528 9',
    email: 'weyhing@trendone.com'
}
